import React from 'react';
import { RequestReceivedPresentational } from './request-received-presentational';

export const RequestReceivedFunctional = ({ history, props }) => {
	const onFinish = (values) => {
		history.push('/login');
		window.location.reload();
	};
	return <RequestReceivedPresentational onFinish={onFinish} />;
};
